// 방송 리소스/애니메이션 라벨 메타 조회 (DB: resource_*, animation_label).
// 파일 자체는 R2(resources/...)에 위치하며, 경로는 @/constants buildResourceUrl 로 만든다.
// 공개 읽기 RLS(anon/authenticated) 이므로 익명 supabase 클라이언트로 조회한다.
import { supabase } from "@/utils/supabase";

const ACTIVE_ORDER = (q) => q.eq("is_active", true).order("sort_order", { ascending: true });

const fetchMusic = async () => {
  const { data, error } = await ACTIVE_ORDER(supabase.from("resource_music").select("label,file_name,storage_key,sort_order,duration_ms"));
  if (error) throw error;
  return data || [];
};

const fetchSoundEffect = async () => {
  const { data, error } = await ACTIVE_ORDER(supabase.from("resource_sound_effect").select("label,file_name,storage_key,sort_order,duration_ms"));
  if (error) throw error;
  return data || [];
};

// category 생략 시 전체. category: "background" | "foreground" | "background-canvas"
const fetchLottie = async (category) => {
  let q = supabase.from("resource_lottie").select("category,label,file_name,storage_key,sort_order");
  if (category) q = q.eq("category", category);
  const { data, error } = await ACTIVE_ORDER(q);
  if (error) throw error;
  return data || [];
};

// clip_name → label_ko 매핑 등 애니메이션 라벨 메타
const fetchAnimationLabels = async () => {
  const { data, error } = await ACTIVE_ORDER(supabase.from("animation_label").select("clip_name,action_id,label_ko,modified_at,sort_order"));
  if (error) throw error;
  return data || [];
};

export default { fetchMusic, fetchSoundEffect, fetchLottie, fetchAnimationLabels };
